import React, { useState } from 'react';

const DateEditor = ({ date, onSave, onCancel, loading }) => {
    const [editedDate, setEditedDate] = useState(() => {
        // Direct formatting without using formatDate utility
        const dateObj = new Date(date);
        if (isNaN(dateObj.getTime())) return '';
        
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        const hours = String(dateObj.getHours()).padStart(2, '0');
        const minutes = String(dateObj.getMinutes()).padStart(2, '0');
        
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    });

    const handleSave = () => {
        if (!editedDate) {
            alert('Please select a valid date and time');
            return;
        }
        onSave(editedDate);
    };

    return (
        <div className="flex items-center gap-2">
            <input
                type="datetime-local"
                value={editedDate}
                onChange={(e) => setEditedDate(e.target.value)}
                className="px-2 py-1 border border-gray-300 rounded text-sm"
                disabled={loading}
            />
            <button
                onClick={handleSave}
                disabled={loading}
                className="px-2 py-1 bg-green-500 text-white rounded text-sm hover:bg-green-600 disabled:opacity-50"
            >
                {loading ? '...' : '✓'}
            </button>
            <button
                onClick={onCancel}
                disabled={loading}
                className="px-2 py-1 bg-gray-500 text-white rounded text-sm hover:bg-gray-600 disabled:opacity-50"
            >
                ✕
            </button>
        </div>
    );
};

export default DateEditor;